<div class="card qai-card p-3 position-relative h-100 shadow-sm"
    [style]="showQuota() ? getGradientStyle(queryHeightPercent()) : null">
    <div class="card-header border-0 pb-0" style="background: transparent;">
        <h5>Totale query</h5>
    </div>
    <div class="card-body">
        <div class="d-flex flex-column justify-content-end h-100" style="min-height: 80px;">
            @if (!loading()) {
                <h1 class="fw-bold text-dark mb-0">{{ totalRequests() }}</h1>
            } @else {
                <h1 class="fw-bold text-dark mb-0 placeholder-glow">
                    <span class="placeholder" style="width: 2ch;"></span>
                    <span class="visually-hidden" i18n>Numero query in caricamento...</span>
                </h1>
            }
            @if (showQuota()) {
                <p class="mb-0 placeholder-glow" [class]="{
                'text-danger': queryHeightPercent() > 80,
                'text-success': queryHeightPercent() < 50,
                'text-warning': queryHeightPercent() >= 50 && queryHeightPercent() <= 80
                }">
                    @if (totalAvailableRequests()) {
                    <span>di {{ totalAvailableRequests() }} disponibili nella tua organizzazione</span>
                    } @else {
                    <span class="placeholder" style="width: 38ch;"></span>
                    }
                </p>
            }
        </div>
    </div>
</div>